// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    logoUrl:'https://www.dataunveil.com/assets/img/logo.png',
    SERVER_ROOT_URL:"https://platform-qa-api.dataunveil.com",
    widgetConfigEndPoint : 'kpi/get-widget-details-by-id',
    apiListEndPoint:'kpi/get-widget-details',
    apiColumnListEndPoint: 'kpi/get-list-of-value',
    getListOfWork:'kpi/get-list-of-work',
    getWorkDetails : 'kpi/get-work-details-by-id',
    addNewWorkList: 'kpi/insert-work-layout',
    infoIconText:"FRMPortal/get-info-text",
    AMPLIFY: {
      region: 'us-east-2',
      userPoolId: 'us-east-2_IBRNnm00y',
      authenticationFlowType: 'USER_PASSWORD_AUTH',
      userPoolWebClientId: '2oubd6j8aae431u2disld0fnge',
    },
    pageAddEditEndPoint: 'kpi/insert-page-details',
    pageListEndPoint: 'kpi/get-page-list',
    ConfigTypeEndPoint: "kpi/get-config-type",
    EnvironmentEndPoint:"kpi/get-environment-type",
    
    patientListFRM: 'FRMPortal/get-patient-list',
    getCycleData : "kpi/get-execution-details",
    getUserInfo : "api/get-user-info",
    getBrandDate : "KPI/get-brand-date",
    MixPanelToken:"d81ca3124927a66ef9e812dbae984bc4",
    MixPanelTrack:true,
    loggingEnabled: true

  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  
